// @flow

import * as React from "react";
import { Manager } from "react-popper";

import Popper from "./Popper";
import Trigger from "./Trigger";
import ModalLauncher from "../ModalLauncher/ModalLauncher";
import type { ControlledTriggerIconTypes } from "./ControlledTriggerIcon/ControlledTriggerIcon";

const mobileWidthBreakpoint = 700;

type TooltipProps = {
  content: () => React.Node,
  additionalTriggerStyles: {
    trigger: string
  },
  type?: ControlledTriggerIconTypes
};

type TooltipState = {
  isOpen: boolean,
  isMobile: boolean
};

class Tooltip extends React.Component<TooltipProps, TooltipState> {
  static defaultProps = {
    content: () => null,
    additionalTriggerStyles: {
      trigger: ""
    }
  };

  state = {
    isOpen: false,
    isMobile: window.innerWidth < mobileWidthBreakpoint
  };

  triggerRef = React.createRef();

  popperRef = React.createRef();

  componentDidMount() {
    document.addEventListener("mouseover", this.handleMouseOverTooltip);
    window.addEventListener("resize", this.handleWindowResize);
  }

  componentWillUnmount() {
    document.removeEventListener("mouseover", this.handleMouseOverTooltip);
    window.removeEventListener("resize", this.handleWindowResize);
  }

  handleMouseOverTooltip = (e: MouseEvent) => {
    const isOpen = this.isMouseOverAnyPartOfTooltip(e.target);

    this.setIsOpen(isOpen);
  };

  isMouseOverAnyPartOfTooltip = (target: EventTarget) =>
    [this.triggerRef, this.popperRef].some(ref => ref.current && ref.current.contains(target));

  handleWindowResize = () => {
    const { isMobile: wasMobile } = this.state;

    const isNowMobile = window.innerWidth < mobileWidthBreakpoint;

    if (wasMobile !== isNowMobile) {
      this.setState({ isMobile: isNowMobile });
    }
  };

  setIsOpen = (isOpen: boolean) => this.setState({ isOpen });

  renderTooltipTrigger = () => {
    const { additionalTriggerStyles, type } = this.props;

    return (
      <Trigger
        triggerRef={this.triggerRef}
        setIsOpen={this.setIsOpen}
        additionalStyles={additionalTriggerStyles}
        type={type}
      />
    );
  };

  renderModalTrigger = () => {
    const { content, additionalTriggerStyles, type } = this.props;

    return (
      <ModalLauncher
        trigger={({ open }) => (
          <Trigger onClick={open} additionalStyles={additionalTriggerStyles} type={type} />
        )}
        header={() => null}
        content={content}
      />
    );
  };

  render() {
    const { content } = this.props;
    const { isOpen, isMobile } = this.state;

    return (
      <Manager>
        {isMobile ? this.renderModalTrigger() : this.renderTooltipTrigger()}
        <Popper isOpen={isOpen} popperRef={this.popperRef} content={content} />
      </Manager>
    );
  }
}

export default Tooltip;
